import { pushTo } from '@app/core/routing';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { useComposition } from '@app/modules/compose/screens/view/hooks/useComposition';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { SocialExportPublishPlatformDropdown } from '@app/modules/social-export/publish';
import { webApi } from '@mi-front/api-clients';
import { useCompositionPublishableRenderedEdits } from './useCompositionPublishableRenderedEdits';

interface ComposeSocialExportPublishDropdownProps {
  uploadsByPlatform: Map<string, webApi.CompositionSocialUploadItemDto[]> | undefined;
}

/**
 * "Publicar en" menu for compositions; navigates to the composition upload wizard per platform.
 */
export function ComposeSocialExportPublishDropdown({
  uploadsByPlatform,
}: ComposeSocialExportPublishDropdownProps) {
  const { composition } = useComposition();
  const { platforms: availablePlatforms } =
    useAvailableSocialExportPlatformsForStation<webApi.CompositionSocialUploadItemDto>(
      composition.stationId ?? undefined,
      uploadsByPlatform,
    );
  const { hasAvailableSources } = useCompositionPublishableRenderedEdits(composition.id);

  const handlePlatformSelect = (platformId: string) => {
    const platform = availablePlatforms.find(
      (p: SocialPlatform) => p.id.toUpperCase() === platformId.toUpperCase(),
    );
    if (platform) {
      pushTo(composeRouteGenerator.upload(composition.id, platform.id));
    }
  };

  return (
    <SocialExportPublishPlatformDropdown
      platforms={availablePlatforms}
      disabled={!hasAvailableSources}
      onSelectPlatform={handlePlatformSelect}
    />
  );
}
